/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface Auth
 */
export interface Auth {
    /**
     * 
     * @type {string}
     * @memberof Auth
     */
    principal: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Auth
     */
    authorities: Array<string>;
    /**
     * 
     * @type {User}
     * @memberof Auth
     */
    user: User;
}

/**
 * Check if a given object implements the Auth interface.
 */
export function instanceOfAuth(value: object): value is Auth {
    if (!('principal' in value) || value['principal'] === undefined) return false;
    if (!('authorities' in value) || value['authorities'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    return true;
}

export function AuthFromJSON(json: any): Auth {
    return AuthFromJSONTyped(json, false);
}

export function AuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): Auth {
    if (json == null) {
        return json;
    }
    return {
        
        'principal': json['principal'],
        'authorities': json['authorities'],
        'user': UserFromJSON(json['user']),
    };
}

export function AuthToJSON(json: any): Auth {
    return AuthToJSONTyped(json, false);
}

export function AuthToJSONTyped(value?: Auth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'principal': value['principal'],
        'authorities': value['authorities'],
        'user': UserToJSON(value['user']),
    };
}

